import React from "react";
import styled from "styled-components";
import { LicenseJsonModel } from "../../models/BlockTransportSystemJsonModel";

interface IProps {
  licenses: LicenseJsonModel[];
  selectedLicenses: LicenseJsonModel[];
  onToggleLicense: (license: LicenseJsonModel) => void;
}

const ModeListBoxWithLicense = ({
  licenses,
  selectedLicenses,
  onToggleLicense
}: IProps) => {

  const isSelected = (license: LicenseJsonModel) => 
    selectedLicenses.some(l => l.id === license.id);

  return (
    <ListContainer>
      {licenses?.map((license) => (
        <Item key={license.id} selected={isSelected(license)} expired={new Date(license.expireDate) < new Date()}>
          <input
            type="checkbox"
            checked={isSelected(license)}
            onChange={() => onToggleLicense(license)}
          />
          <Label onClick={() => onToggleLicense(license)}>
            {license?.name}
          </Label>
        </Item>
      ))}
    </ListContainer>
  )
}

export default ModeListBoxWithLicense;

const ListContainer = styled.div`
  height: 500px;
  width: 950px;
  overflow: scroll;
`;

const Item = styled.div<{selected: boolean, expired: boolean}>`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.selected 
    ? "#3969ed" 
    : props.expired 
      ? "#f01f1f" 
      : "#f0f0f0"};
  margin: 2px;
  padding: 2px;
`;

const Label = styled.label`
  margin-left: 8px;
  cursor: pointer;
`;